<template>
  <LayoutTelas
    id="tela__clientes"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <ClientesCadastroForm
      ref="formCliente"
      :dados="dadosCliente"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import ClientesCadastroForm from './ClientesCadastroForm.vue'
import ClienteService from '../../../services/clientes.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'
import usuarioStorage from '../../../local-storage/usuarioStorage'

export default {
  name: 'ClientesCadastro',
  components: {
    ClientesCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosCliente: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(dados)
        if (retorno.documento) {
          usuarioStorage.setCliente(retorno.documento)
        }
        this.tratarRespostaMsg(retorno)

        this.$refs.formCliente.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    retornaMetodoGravacao(dados) {
      return dados._id
        ? ClienteService.atualizar(dados)
        : ClienteService.gravar(dados)
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosCliente = await ClienteService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-clientes' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__clientes {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
